import React, { useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import ReactToPrint from "react-to-print";
import Button from '@material-ui/core/Button';
import PrintIcon from '@material-ui/icons/Print';
import FylgibrefToPrint from 'pages/skraning/atkvaedi/components/print/fylgibref/FylgibrefToPrint';

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing()
  }
}));

const PrintFylgibref = (props) => {
  const classes = useStyles();
  const { formState, kjosandi, kosning } = props;
  const fylgibrefToPrintRef = useRef();

  return (
    <React.Fragment>
      <div>
        <ReactToPrint
          trigger={() => (
            <Button color="primary" variant="contained">
              <PrintIcon className={classes.icon} />
              Prenta fylgibréf
            </Button>
          )}
          content={() => fylgibrefToPrintRef.current}
        />

        <div style={{ display: "none" }}>
          <FylgibrefToPrint
            formState={formState}
            kjosandi={kjosandi}
            activeKosning={kosning}
            ref={fylgibrefToPrintRef}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default PrintFylgibref;